import React, { useCallback, useContext, useState } from 'react'
import useFetchingData from '../../../_commons/Hooks/useFetchingData';
import { useDynamicContentDialog } from '../../../_commons/Utils/React/Components/Dialogs/SimpleDialog';
import { ILMSCourseModel } from '../../../_services/CMSServices/Models';
import useBasicInput from '../../../_commons/Hooks/useHTMLInput';
import { useLeftRightStyle } from './useLeftRightStyle';

import { AcademyContext } from '../../../_contexts/UserContext';
import { ILiveNotification, LiveNotificationCMSApi } from '../../../_services/CMSServices/LiveNotificationCMSApi';
import LiveNotificationEditor, { AddOrEditLiveNotification } from './LiveNotificationEditor';

export interface ILiveNotificationViewModel {
    liveNotificationId?: number,
    notificationTitle: string,
    notificationContent: string
}
export default function LiveNotificationManagement() {

    const { loginState: { accessToken } } = useContext(AcademyContext);
    const token = accessToken ?? "";

    const classes = useLeftRightStyle();
    const searchInput = useBasicInput();


    const { data: objs, handleRefresh: refreshData } = useFetchingData<ILiveNotification[]>(

        useCallback(
            (setData) => {
                LiveNotificationCMSApi.GetAll(token).then((data) => {
                    if (data)
                        setData(data);
                    else
                        setData(null);
                }).catch(() => {
                    setData(null);
                })
            },
            [token],
        )
    )

    const [_selectedObjId, setSelectedObjId] = useState<number | undefined | null>(undefined);


    const useDialog = useDynamicContentDialog({ maxWidth: 'lg', fullWidth: true });



    const renderLeftContainer = () => {
        return <>
            <label>Search Live Notifcation {searchInput.render()} </label>
            {
                objs === undefined ? <div>is Loading</div> :
                    objs === null ? <div> fetching failed</div> :
                        <ul>

                            {
                                objs.filter((value: ILiveNotification) => value.notificationTitle.toLowerCase().includes(searchInput.value.toLowerCase())).map((value: ILiveNotification, index: number) => {

                                    return <li
                                        style={{ cursor: "pointer" }}
                                        onClick={() => { setSelectedObjId(value.liveNotificationId) }}>{value.notificationTitle}
                                    </li>
                                })
                            }

                        </ul>

            }
        </>
    }
    const handleAdd = (obj: ILiveNotification) => {
        accessToken && LiveNotificationCMSApi.Update("ADD", obj, accessToken).then(
            result => {
                if (result) {
                    refreshData();
                    alert("Added")
                    setSelectedObjId(undefined);
                } else {
                    alert("Failed");
                }

            }
        )
    }
    const handleEdit = (obj: ILiveNotification) => {
        accessToken && LiveNotificationCMSApi.Update("EDIT", obj, accessToken).then(
            result => {
                if (result) {
                    refreshData();
                    alert("Change Saved")
                } else {
                    alert("Failed");
                }

            }
        )
    }
    const renderRightContainer = () => {
        const selectedObj = objs?.find(n => n.liveNotificationId === _selectedObjId);

        return _selectedObjId === undefined ? <div> select a notification</div> :
            _selectedObjId === null ? <AddOrEditLiveNotification
                onSubmit={handleAdd}
            /> :
                selectedObj &&
                <LiveNotificationEditor
                    liveNotification={selectedObj}
                    onEditSubmit={handleEdit}
                />

    }
    const handleAddClick = () => {
        setSelectedObjId(null)
    }
    return (
        <div className={`${classes.root}`}>

            <div className={classes.leftContainer}>
                <button onClick={handleAddClick}>Add </button>
                {renderLeftContainer()}
            </div>
            <div className={classes.rightContainer}>
                {renderRightContainer()}
            </div>

            {useDialog.render()}
        </div>
    )
}
